import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import classNames from "classnames";
import { useValidationBlur } from "../../hooks/use-validation-blur";

export const OutlinedDatePicker = ({
  value,
  onChange,
  label,
  disabled = false,
  isValid = false,
  validationText,
  helperText,
  error,
}: {
  label?: string;
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  isValid?: boolean;
  validationText?: string;
  helperText?: string;
  error?: string;
}) => {
  const { shouldValidate, onBlur } = useValidationBlur();

  const isInvalidState = !isValid && shouldValidate && !disabled && !!error;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        sx={{
          width: "100%",
        }}
        disabled={disabled}
        className={classNames(
          "hdg-date-picker",
          !isValid && shouldValidate && "error"
        )}
        label={label}
        value={value ? dayjs(value) : null}
        onClose={onBlur}
        slotProps={{
          textField: {
            onBlur: onBlur,
            error: isInvalidState,
            helperText:
              isInvalidState && !!validationText ? validationText : helperText,
          },
        }}
        onChange={(changeValue) =>
          onChange(
            changeValue ? changeValue?.format("YYYY-MM-DD") : changeValue
          )
        }
      />
    </LocalizationProvider>
  );
};
